import { AuthApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPostSendVerificationCode = () => {
    const { t } = useTranslation('newNotifications');
    const authApi: AuthApi = useContainer(AuthApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (email: string) => {
        const { exec, abort } = authApi.resendConfirmationCode({
            body: { email },
            onError: _ => {
                toastHandler.push('error', t('auth.sendVerificationCodeTitle'), t('auth.sendVerificationCodeMessage_Failed'));
            },
        });
        exec();
        return abort;
    };

    return {
        exec,
    };
};

export default useHttpPostSendVerificationCode;
